import { ApisauceConfig, create } from 'apisauce';
import { validateApiResponse } from './utils';

export type ApiInstanceConfig = Omit<ApisauceConfig, 'baseURL'> & {
  url?: string;
  throwOnError?: boolean;
};

export const apiInstance = ({
  url: baseURL = undefined,
  headers,
  throwOnError,
  ...config
}: ApiInstanceConfig = {}) => {
  const instance = create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      // 'X-Robocloud-UI-Version': encodeURIComponent(import.meta.env.VITE_BUILD_INFO),
      ...headers,
    },
    ...config,
  });

  /**
   * Disabled by default as this gets also used by redux actions.
   * Once redux actions are replaced by react query this can be enabled to remove all the duplicates on query level.
   */
  if (throwOnError === true) {
    instance.addResponseTransform((response) => validateApiResponse(response));
  }

  return instance;
};
